(function ($) {
    var throttle = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) {
            options = {};
        }
        var later = function () {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) {
                context = args = null;
            }
        };
        return function () {
            var now = Date.now();
            if (!previous && options.leading === false) {
                previous = now;
            }
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) {
                    context = args = null;
                }
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };
    window.UNantes = {
        design: {
            fontsize: 16,
            breakingpoints: {}
        }
    };
    window.UNantes.design.breakingpoints.js_small = 640;
    window.UNantes.design.breakingpoints.small_medium = 1024;
    window.UNantes.design.breakingpoints.medium_large = 1280;
    // Delegate .transition() calls to .animate()
    // if the browser can't do CSS transitions.
    if (!$.support.transition) {
        $.fn.transition = $.fn.animate;
    }
    /**
     * Locale de la page courante
     */
    var locale = $('html').attr('lang');
    /**
     * Initialisation des champs de type date
     */
    $('.type_date').datepicker($.datepicker.regional[locale]);
    /**
     * Les rubriques externes doivent s'ouvrir dans des nouvelles
     */
    $('ul:not(#menu_principal) > li > a.type_rubrique_0004').click(function (e) {
        e.preventDefault();
        window.open(this.href);
        return false;
    });
    /**
     * Permet d'associer un rôle de "fermeture" à un bouton. Code à suivre :
     * <div>
     *     <button role="close">&times;</button>
     *     <!-- ... -->
     * </div>
     */
    $(document).on('click', '[role="close"]', function () {
        $(this).parent().hide();
    });
    /**
     * Datagrid des résultats de recherche de formations
     */
    var $resultatSelecteur = $("#resultatSelecteur");
    if ($resultatSelecteur) {
        $resultatSelecteur.dataTable();
    }
    /**
     * Share actions
     */
    $('.js-share-action').on('click', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        window.open(href, '', 'height=400,width=600,titlebar=yes');
        return false;
    });
    // Owl Carousel
    $('.owl-carousel').each(function () {
        var $t = $(this);
        if (!!$t.attr('data-context')) {
            return;
        }
        var willBeAnimated = $t.find('.item').length > 1;
        $t.owlCarousel({
            items: 1,
            loop: willBeAnimated,
            nav: false,
            dots: true,
            margin: 0,
            autoplay: willBeAnimated,
            mouseDrag: willBeAnimated,
            touchDrag: willBeAnimated,
            autoplayTimeout: willBeAnimated ? 5000 : 0,
            autoplayHoverPause: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: true
                },
                600: {
                    items: 1,
                    nav: false
                }
            }
        });
    });
    var responsiveCarrouselActualitesParams = {};
    responsiveCarrouselActualitesParams[0] = {
        items: 1
    };
    responsiveCarrouselActualitesParams[window.UNantes.design.breakingpoints.js_small] = {
        items: 2
    };
    responsiveCarrouselActualitesParams[window.UNantes.design.breakingpoints.medium_large] = {
        items: 4
    };
    $('.carrousel-actualites__slides').each(function () {
        var $t = $(this);
        var willBeAnimated = $t.find('.item').length > 4;
        $t.owlCarousel({
            items: 4,
            loop: willBeAnimated,
            nav: false,
            dots: false,
            margin: 10,
            autoplay: false,
            mouseDrag: willBeAnimated,
            touchDrag: willBeAnimated,
            autoplayTimeout: 0,
            autoplayHoverPause: true,
            responsiveClass: true,
            responsive: responsiveCarrouselActualitesParams
        });
        $t.find('.owl-nav').find('div.owl-prev, div.owl-next').remove();
        if (willBeAnimated) {
            $t.find('.owl-nav')
                .prepend('<button class="owl-prev button button-link"><span aria-hidden="true">&lt;</span><span class="sr-only">' + OWL_CAROUSEL.messages.previous + '</span></button>')
                .append('<button class="owl-next button button-link"><span aria-hidden="true">&gt;</span><span class="sr-only">' + OWL_CAROUSEL.messages.next + '</span></button>');
            $t.find('.owl-nav .owl-prev').click(function () {
                $t.trigger('prev.owl.carousel');
            }).end().find('.owl-nav .owl-next').click(function () {
                $t.trigger('next.owl.carousel');
            });
        }
    });
    const adjustCarrouselActuNavPosition = function () {
        const carrouselsActualites = document.getElementsByClassName('carrousel-actualites');
        if (carrouselsActualites !== undefined && carrouselsActualites !== null) {
            for (c of carrouselsActualites) {
                const referenceElement = c.getElementsByClassName('slide-actu__image')[0];
                if (referenceElement === undefined) {
                    return;
                }
                var referenceElementHeight = referenceElement.offsetHeight;
                var computedMargin = (referenceElementHeight - 50) / 2;
                c.querySelectorAll('.owl-nav>button').forEach(e => e.style.top = computedMargin + "px");
            }
        }
    };
    let timeout = false;
    const delay = 250;
    window.addEventListener('resize', function () {
        clearTimeout(timeout);
        timeout = setTimeout(adjustCarrouselActuNavPosition, delay);
    });
    setTimeout(adjustCarrouselActuNavPosition, 2000);

    function matches(el, selector) {
        if (!el) {
            return false;
        }
        var matchesCallable = (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector);
        if (!matchesCallable) {
            return false;
        }
        return matchesCallable.call(el, selector);
    }

    function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    }

    function parentMatches(el, selector) {
        return closest(el, function (e) {
            return matches(e, selector);
        }) !== null;
    }

    (new DataToggle({
        triggerMethods: {
            button: {
                trigger: function (element, target, options, callback) {
                    var handleClick = (event) => {
                        return callback(event, {
                            callback: (el) => {
                                const targetedElements = Array.from(document.querySelectorAll('[data-toggle][aria-expanded]'))
                                for (const targetedElement of targetedElements) {
                                    targetedElement.setAttribute('aria-expanded', targetedElement.classList.contains('active'))
                                }
                            }
                        });
                    };
                    element.addEventListener('click', handleClick, false);
                    return {
                        click: handleClick
                    };
                },
                preventingCallback: function ($element, $target, $el, options) {
                    return false;
                }
            },
            check: {
                trigger: function (element, target, options, callback) {
                    var handleChange = function (event) {
                        var status = element.checked;
                        /*
                         this callback updates checkboxes. Without this callback, classes will be added to
                         controls, but they won't change their status.
                         */
                        return callback(event, {
                            status: status,
                            callback: function (el, elStatus) {
                                if (el.hasAttribute('type')
                                    && (el.getAttribute('type') === 'radio' || el.getAttribute('type') === 'checkbox')) {
                                    if (elStatus === true || elStatus === false) {
                                        el.checked = elStatus;
                                    } else {
                                        el.checked = !el.checked;
                                    }
                                }
                            }
                        });
                    };
                    element.addEventListener('change', handleChange, false);
                    return {
                        change: handleChange
                    };
                },
                // Here we have to cancel data-toggle behavior when clicking on labels associated to input.
                preventingCallback: function (event, $element, $target, $el, options) {
                    if ($el.tagName.toLowerCase() === 'label' && $el.hasAttribute('for')) {
                        var forElement = document.getElementById($el.getAttribute('for'));
                        var dataToggles = options.dataToggleElements();
                        if (filter(dataToggles, forElement).length > 0) {
                            return true;
                        }
                    }
                    return false;
                }
            }
        },
        preventingCallback: function (event, $element, $target, $el) {
            if (parentMatches($el, '[data-toggle-group-keep].active')) { // prevent close of tab contents)
                if (!matches($el, '[data-toggle-allow-default]')) {
                    event.preventDefault();
                }
                return true;
            }
            return (
                parentMatches($el, '.kTree') ||
                parentMatches($el, '.ui-dialog') ||
                parentMatches($el, '.owl-carousel') ||
                parentMatches($el, '.plier-deplier') ||
                parentMatches($el, '.kmultiselect-ltl') ||
                (parentMatches($el, '[data-toggle-target]') && !matches($el, '[data-toggle]')) || matches($el, '[data-toggle-target]')// prevent click inside dropdowns
            );
        }
    }));
    document.body.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            const clickEvent = new MouseEvent('click', {})
            document.body.dispatchEvent(clickEvent)
        }
    })
    let activeMenu = null
    window.addEventListener('load', () => {
        const elements = document.querySelectorAll('body, .menu__level-wrapper[data-toggle-target]')
        for (const element of elements) {
            element.addEventListener('menu', () => {
                let opener = null
                if (!!activeMenu) {
                    opener = activeMenu
                }
                activeMenu = document.querySelector('.menu_institutionnel [data-toggle-event="menu"][data-toggle-group].active, .menu-wrapper [data-toggle-event="menu"].active')
                document.body.classList.toggle('is-menu-open', !!activeMenu)
                if (!activeMenu && !!opener) {
                    opener.focus()
                }
            })
        }
        const menuPrincipal = document.getElementById('menu_principal')
        const menuObserver = new MutationObserver(([ mutation ]) => {
            menuPrincipal.setAttribute('aria-hidden', menuPrincipal.classList.contains('show-menu') ? 'false' : 'true')
        })
        menuObserver.observe(menuPrincipal, {
            attributeFilter: [ 'class' ]
        })
    })
    // ACCORDEONS ANIMATIONS
    var getHeightOf = function (el) {
        var $element = typeof el === 'string' ? document.querySelector(el) : el;
        var $clone = $element.cloneNode(true);

        // Images
        var images = Array.from($clone.querySelectorAll('img'));
        var promises = images.map(img => {
            if (img.complete) return Promise.resolve();
            return new Promise(resolve => { img.onload = img.onerror = resolve; });
        });

        // Polices
        if (document.fonts) {
            promises.push(document.fonts.ready);
        }

        el.parentNode.insertBefore($clone, $element.nextSibling);
        $clone.style.display = 'block';
        $clone.style.height = 'auto';
        $clone.style.overflow = 'hidden';
        $clone.style.opacity = 0;
        $clone.style.position = 'relative';
        $clone.style['z-index'] = '-1000';

        return Promise.all(promises).then(() => {
            return new Promise(resolve => {
                requestAnimationFrame(() => {
                    var height = $clone.clientHeight;
                    el.parentNode.removeChild($clone);
                    resolve(height);
                });
            });
        });
    };

    function accordeonize({
                              mainSelector,
                              titleSelector,
                              contentSelector,
                              activeClass = 'active',
                              eventName = 'accordeon-animation'
                          }) {
        const accordeons = Array.from(document.querySelectorAll(mainSelector));
        for (const accordeon of accordeons) {
            accordeon.querySelector(titleSelector).addEventListener('click', () => {
                const event = new CustomEvent(eventName);
                const contenuElement = accordeon.querySelector(contentSelector);
                accordeon.classList.toggle(activeClass);
                const isActive = accordeon.classList.contains(activeClass);
                contenuElement.classList.toggle(activeClass, isActive);
                contenuElement.toggleAttribute('inert', !isActive);
                contenuElement.dispatchEvent(event);
            });
        }
    }

    accordeonize({
        mainSelector: '.paragraphe--6',
        titleSelector: '.paragraphe__titre--6',
        contentSelector: '.paragraphe__contenu--6'
    });
    accordeonize({
        mainSelector: '.paragraphe--7',
        titleSelector: '.paragraphe__titre--7',
        contentSelector: '.paragraphe__contenu--7'
    });
    [].forEach.call(document.querySelectorAll('[data-toggle-odf-id]'), function (element) {
        element.addEventListener('accordeon-animation', function (e) {
            var isActive = e.target.classList.contains('active');
            getHeightOf(e.target).then(measuredHeight => {
                var before = isActive ? 0 : measuredHeight;
                var after = isActive ? measuredHeight : 0;
                animate(function (h) {
                    e.target.style.height = h + 'px';
                }, before, after, 500);
                if (!before) {
                    var yFix = 108; // sticky bar fix
                    var from = window.scrollY;
                    var to = getOffsetTop(e.target) - yFix;
                    animate(function (y) {
                        window.scrollTo(0, y);
                    }, from, to, 500);
                }
            });
        });
    });
    [].forEach.call(document.querySelectorAll('.paragraphe__contenu--6'), function (element) {
        element.addEventListener('accordeon-animation', function (e) {
            var isActive = e.target.classList.contains('active');
            getHeightOf(e.target).then(measuredHeight => {
                var before = isActive ? 0 : measuredHeight;
                var after = isActive ? measuredHeight : 0;
                animate(function (h) {
                    e.target.style.height = h + 'px';
                }, before, after, 500);
            });
        });
    });
    [].forEach.call(document.querySelectorAll('.paragraphe__contenu--7'), function (element) {
        element.addEventListener('accordeon-animation', function (e) {
            var isActive = e.target.classList.contains('active');
            getHeightOf(e.target).then(measuredHeight => {
                var before = isActive ? 0 : measuredHeight;
                var after = isActive ? measuredHeight : 0;
                animate(function (h) {
                    e.target.style.height = h + 'px';
                }, before, after, 500);
            });
        });
    });
    if (document.querySelector('#recherche-simple')) {
        var beforeRechercheSimple = null;
        document.body.addEventListener('toggle-search', function (ev) {
            if (beforeRechercheSimple === null) {
                beforeRechercheSimple = ev.relatedTarget || ev.explicitOriginalTarget || document.activeElement;
            }
            document.querySelector('#MOTS_CLEFS').focus();
        });
        var escBind = function (e) {
            if (e.keyCode === 27 || e.which === 27) { // ESC
                [].forEach.call(document.querySelectorAll('.recherche-simple'), function (element) {
                    element.classList.remove('recherche-simple');
                    if (!!beforeRechercheSimple) {
                        beforeRechercheSimple.focus();
                        beforeRechercheSimple = null;
                    }
                });
            }
        };
        var odfBind = document.querySelector('body.fiche.formation');
        if (odfBind) {
            var specificitesAnchorLink = odfBind.querySelector('a[href="#specificites"]');
            if (specificitesAnchorLink) {
                var presentationWrapper = odfBind.querySelector('a[href="#presentation"].more');
                if (presentationWrapper) {
                    specificitesAnchorLink.addEventListener('click', function () {
                        if (!presentationWrapper.classList.contains('active')) {
                            presentationWrapper.click();
                        }
                    });
                }
            }
        }
        [].forEach.call(document.querySelectorAll('#recherche-simple .toolbar__component__dropdown, #MOTS_CLEFS'), function (element) {
            element.addEventListener('keydown', escBind);
        });
    }

    function switchCookieState() {
        var $refuse = $('.cookie__button--refuse'),
            $accept = $('.cookie__button--accept'),
            $status = $('.cookie__status');
        if (CookieCNIL.hasConsent()) {
            $accept.css('display', 'none');
            $refuse.css('display', 'inline-block');
            $status.html('<span class="icon icon-checkmark" style="color: #009B06"></span>' + COOKIES_CNIL.messages.accepted);
        } else {
            $refuse.css('display', 'none');
            $accept.css('display', 'inline-block');
            $status.html('<span class="icon icon-close" style="color: #c50202"></span>' + COOKIES_CNIL.messages.refused);
        }
    }

    $('.cookie__button--accept').click(function () {
        CookieCNIL.accept();
        switchCookieState();
    });
    $('.cookie__button--refuse').click(function () {
        CookieCNIL.decline();
        switchCookieState();
    });
    if (window.CookieCNIL) {
        switchCookieState();
    }

    function getOffsetTop(elem) {
        var offsetTop = 0;
        do {
            if (!isNaN(elem.offsetTop)) {
                offsetTop += elem.offsetTop;
            }
        } while (elem = elem.offsetParent);
        return offsetTop;
    }

    var doScrolled = function () {
        var elem = document.querySelector('.toolbar');
        var actualPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (actualPosition > getOffsetTop(elem) + elem.offsetHeight - 48) { // 48 = ux fix
            document.body.classList.add('sticky-toolbar');
        } else {
            document.body.classList.remove('sticky-toolbar');
        }
    };
    if (!(document.body.classList.contains('site--institutionnel'))) {
        window.addEventListener('load', doScrolled);
        window.addEventListener('scroll', doScrolled);
    }
    var HomeSequence = (function () {
        return {
            start: function () {
                var self = this;
                var video = document.querySelector('.headerCard__background video');
                if (video) {
                    var doPlayVideo = function () {
                        document.body.classList.add('animate-header');
                        window.setTimeout(function () {
                            self.end.call(self);
                        }, 2000);
                        video.addEventListener('ended', function () {
                            video.classList.add('disappear');
                        });
                        video.play();
                    };
                    if (video.readyState !== 4) {
                        video.addEventListener('canplaythrough', doPlayVideo);
                    } else {
                        doPlayVideo();
                    }
                } else {
                    document.body.classList.add('animate-header');
                    window.setTimeout(function () {
                        self.end.call(self);
                    }, 2000);
                }
            },
            end: function () {
                var videoPlaceholder = document.querySelector('.headerCard__background .video-placeholder');
                videoPlaceholder.classList.add('appear');
                document.body.classList.add('animate-header--step-2');
            }
        };
    })();
    var mimeType = function (url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('HEAD', url);
        xhr.onreadystatechange = function () {
            if (this.readyState === this.DONE) {
                callback(this.getResponseHeader('Content-Type'));
            }
        };
        xhr.send();
    };
    var canPlay = function (video, success, error) {
        var url = video.getAttribute('src');
        mimeType(url, function (mime) {
            if (video.canPlayType(mime)) {
                success();
            } else {
                error();
            }
        });
    };
    var skipVideo = function () {
        var video = document.querySelector('.headerCard__background video');
        var videoPlaceholder = document.querySelector('.headerCard__background .video-placeholder');
        document.body.classList.add('animate-header');
        document.body.classList.add('animate-header--step-2');
        if (video) {
            video.parentNode.removeChild(video);
        }
        if (videoPlaceholder) {
            videoPlaceholder.classList.add('appear');
        }
    };
    var doAnimation = function () {
        var video = document.querySelector('.headerCard__background video');
        if (video === null || window.innerWidth < window.UNantes.design.breakingpoints.small_medium) {
            skipVideo();
        } else {
            canPlay(video, function success() {
                video.onerror = function () {
                    skipVideo();
                };
                video.load();
                HomeSequence.start();
            }, function error() {
                skipVideo();
            });
        }
    };
    if (document.body.classList.contains('ficheaccueil') && !document.body.classList.contains('site--magazine')) {
        if (document.body.classList.contains('has-alerte')) {
            var alertePopup = new UNantesAlerte();
            var message = alertePopup.encodeMessage('[data-modal-unantes="alerte"] .modal__description');
            if (alertePopup.willAlertBeShown(message)) {
                window.addEventListener('modal-unantes.afterclose', function (event) {
                    if (event.detail.modal.classList.contains('message-alerte')) {
                        doAnimation();
                    }
                });
            } else {
                doAnimation();
            }
        } else {
            doAnimation();
        }
    }
    var ScrollTo = function (options) {
        function extend() {
            for (var i = 1; i < arguments.length; i++) {
                for (var key in arguments[i]) {
                    if (arguments[i].hasOwnProperty(key)) {
                        arguments[0][key] = arguments[i][key];
                    }
                }
            }
            return arguments[0];
        }

        function forEach(elements, callback) {
            return [].forEach.call(elements, callback);
        }

        function query(selector, callback) {
            return forEach(document.querySelectorAll(selector), callback);
        }

        var instance = {
            options: {
                scroller: {
                    get: function () {
                        var supportPageOffset = window.pageXOffset !== undefined;
                        var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
                        return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
                    },
                    set: function (position) {
                        window.scroll(0, position);
                    }
                },
                triggerSelector: '[data-scroll-to]',
                targetSelection: function (element) {
                    return element.getAttribute('data-scroll-to') || element.getAttribute('href');
                },
                durationAttr: function (element) {
                    return element.getAttribute('data-scroll-to-duration');
                },
                yfixAttr: function (element) {
                    return element.getAttribute('data-scroll-to-yfix');
                },
                yFix: 0,
                duration: 2000
            },
            __construct: function (options) {
                this.options = extend(this.options, options || {});
                this.bindElements.call(this);
            },
            bindElements: function () {
                var self = this;
                query(this.options.triggerSelector, function (element) {
                    element.addEventListener('click', function (e) {
                        e.preventDefault();
                        var trigger = e.currentTarget;
                        if (!trigger) {
                            return false;
                        }
                        var target = self.options.targetSelection(trigger);
                        var duration = self.options.durationAttr(trigger) || self.options.duration;
                        var yFix = self.options.yfixAttr(trigger) || self.options.yFix;
                        var scrollPosition = self.options.scroller.get();
                        var scrollDestination = (function getOffsetTop(elem, defaultValue) {
                            if (elem) {
                                var offsetTop = 0;
                                do {
                                    if (!isNaN(elem.offsetTop)) {
                                        offsetTop += elem.offsetTop;
                                    }
                                } while (elem = elem.offsetParent);
                                return offsetTop;
                            } else {
                                return defaultValue;
                            }
                        })(document.querySelector(target), scrollPosition) - yFix;
                        animate(function (value) {
                            self.options.scroller.set(value);
                        }, scrollPosition, scrollDestination, duration, 'easeOutQuad');
                        return false;
                    });
                });
            }
        };
        instance.__construct(options);
        return instance;
    };
    if (!(document.body.classList.contains('site--institutionnel'))) {
        new ScrollTo({
            yFix: 56,
            duration: 2000
        });
    }
    // COUNTER
    window.addEventListener('load', function () {
        function executeCounter(counter, value, duration) {
            value = value.split(',').join('.').split(' ').join('');
            var digitsAfterComma = value.indexOf('.') >= 0 ? value.split('.')[1].length : 0;
            animate(function (x) {
                counter.innerHTML = x.toFixed(digitsAfterComma);
            }, 0, value, duration, 'easeOutCubic');
        }

        /* [].forEach.call(document.querySelectorAll('[data-counter-unantes]'), function(counter) {
            var callback = function() {
                executeCounter(counter, counter.getAttribute('data-counter-unantes'), counter.getAttribute('data-counter-unantes-duration-ms'));
            };
            if (counter.hasAttribute('data-counter-unantes-start-on')) {
                counter.addEventListener(counter.getAttribute('data-counter-unantes-start-on'), callback);
            } else {
                callback();
            }
        });

        [].forEach.call(document.querySelectorAll('[data-start-counters]'), function(element) {
            element.addEventListener('start-counters', function() {
                var countersEvent = element.getAttribute('data-start-counters');
                var event = new CustomEvent(countersEvent);
                [].forEach.call(document.querySelectorAll('[data-counter-unantes-start-on="' + countersEvent + '"]'), function(counter) {
                    counter.dispatchEvent(event);
                });
            });
        }); */
        // Chapters
        [].forEach.call(document.querySelectorAll('[data-chapters]'), function (zone) {
            var zoneId = zone.getAttribute('data-chapters');
            [].forEach.call(zone.querySelectorAll('[data-chapter-nav]'), function (nav) {
                nav.addEventListener('click', function (e) {
                    e.preventDefault();
                    var scrollZone = document.querySelector('[data-chapters-zone="' + zoneId + '"]');
                    var navId = nav.getAttribute('data-chapter-nav');
                    var start = scrollZone.scrollTop;
                    var end = scrollZone.querySelector('[data-chapter="' + navId + '"]').offsetTop - scrollZone.offsetTop;
                    animate(function (value) {
                        scrollZone.scrollTop = value;
                    }, start, end, 500);
                    return false;
                });
            });
        });
        var $grid = $('.js-grid');
        [].forEach.call(document.querySelectorAll('[data-post-id]'), function (post) {
            var contents = post.querySelector('.social-feeds__grid__item__contents').textContent;
            if (contents.length > 200) {
                post.classList.add('with-hider');
            }
            post.addEventListener('masonry-layout', function () {
                $grid.masonry('layout');
            });
        });
        // Scrollspy
        var scrollSpyFix = document.body.classList.contains('site--institutionnel') ? 80 : 56;
        var bindScrollSpy = function () {
            [].forEach.call(document.querySelectorAll('[data-scrollspy]'), function (element) {
                var $target = document.querySelector(element.getAttribute('data-scrollspy'));
                if (!!$target) {
                    var rect = $target.getBoundingClientRect();
                    if (rect.top <= scrollSpyFix && rect.bottom >= scrollSpyFix) {
                        if (!element.classList.contains('current')) {
                            element.classList.add('current');
                        }
                    } else {
                        if (element.classList.contains('current')) {
                            element.classList.remove('current');
                        }
                    }
                }
            });
        };
        window.addEventListener('scroll', throttle(bindScrollSpy, 100));
    });
    // Fonctionnalité de visualisation d'une image
    $('a[data-imgmagnifier]').magnificPopup({
        type: 'image'
    });
    $(document).on('click', '.autocomplete-suggestions', function () {
        // Patch permettant l'utilisation de plusieurs autocomplete dans une même page, voir autocomplete.js également
        $('.js-submittedForm').submit();
    });
    // si aucune classe hide-mega_menu et show-mega_menu sur la balise html, on vient ajouter la classe "hide-megamenu" pour faire du toggle par defaut
    $('.open-menu--mega-menu').click(function (e) {
        if (!($('html').hasClass('hide-megamenu') && $('html').hasClass('show-megamenu'))) {
            $('html').addClass('hide-megamenu');
        }
    });
    // Gestion du cookie du mega menu
    // Ce cookie enregistre la préférence de l'utilisateur pour la session, d'afficher ou non la colonne d'actualités du mega menu.
    // Par défaut, la colonne est affichée.
    var megamenuCookieName = "megamenu-hide-actu";
    $(document).ready(function () {
        $(".mega-menu_wrapper").css("display:block");
        $(body).addClass("loaded");
    });
    var getClosest = function (elem, selector) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (i >= 0 && matches.item(i) !== this) {
                        --i;
                    }
                    return i > -1;
                };
        }
        // Get closest match
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) {
                return elem;
            }
        }
        return null;
    };
    // Traitement du formulaire de recheche par métier
    [].forEach.call(document.querySelectorAll('.metiers-autocomplete'), function (element) {
        element.addEventListener('addItem', function (event) {
            // alimenter le champ saisi
            var form = getClosest(element, 'form');
            if (form) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", "METIER");
                hiddenField.setAttribute("value", event.detail.value);
                form.append(hiddenField);
                form.submit();
            }
        }, false);
    });
    //Ajout de champs dans la recherche carte d'accueil
    var $rechercheformation = document.getElementById('recherche-formation');
    if ($rechercheformation) {
        $rechercheformation.addEventListener('submit', function (e) {
            //On gère ici le résultat de la sélection de lieu
            if (this.lieu && this.lieu.options && this.lieu.options[this.lieu.selectedIndex]) {
                var lieu = this.lieu.options[this.lieu.selectedIndex].value;
                if (lieu && lieu != "") {
                    var hiddenLieuField = document.createElement("input");
                    hiddenLieuField.setAttribute("type", "hidden");
                    hiddenLieuField.setAttribute("name", "lieu");
                    hiddenLieuField.setAttribute("value", lieu);
                    this.appendChild(hiddenLieuField);
                }
            }
            //On gère ici le résultat de la sélection de type de formation
            if (this.typeFormCont && this.typeFormCont.options && this.typeFormCont.options[this.typeFormCont.selectedIndex]) {
                var type = this.typeFormCont.options[this.typeFormCont.selectedIndex].value;
                if (type && type != "") {
                    var hiddenLieuField = document.createElement("input");
                    hiddenLieuField.setAttribute("type", "hidden");
                    hiddenLieuField.setAttribute("name", "typeFormCont");
                    hiddenLieuField.setAttribute("value", type);
                    this.appendChild(hiddenLieuField);
                }
            }
        });
    }

    function initBindActualites() {
        // Au clic, on ouvre les icones de partage d'evenement
        // Doit pouvoir fonctionner même si les éléments sont rajoutés après l'initialisation du dom (donc capture large sur le body)
        $('body').on('click', '.agenda__addevent', function onClickAgendaEvent() {
            $(this).toggleClass('agenda__addevent--open');
        });
    }

    $(window).load(function () {
        initBindActualites();
        //Gestion de l'affichage du tooltip en responsive
        responsiveTooltip();
    });

    /**
     * Modifie la position du tooltip en responsive
     * (affichage en dessous de la barre de recherche)
     */
    function responsiveTooltip() {
        const largeWidth = 1570
        if (document.body.classList.contains('recherche')) {
            const form = document.querySelector('form#search_query_input')
            if (form) {
                const searchbar = form.querySelector('input#q')
                searchbar.addEventListener('focus', () => {
                    if ($(window).width() < largeWidth) {
                        let tooltip = form.querySelector('.tooltip')
                        tooltip.style = 'width:auto;'
                        tooltip.className = 'tooltip fade bottom in'
                    }
                })
            }
        }
    }

    /**
     * Script permettant de détecter les liens ayant pour style bouton-matomo1 ou bouton-matomo2.
     * Le script attribut un id au lien généré à partir du hash de la balise et attribut également la classe bouton-matomo1 ou bouton-matomo2
     * afin d'être détecté par matomo lors du clique sur celui-ci.
     */
    function prepareBoutonMatomo(aElement, el, classToAdd) {
        if (!!aElement) {
            aElement.setAttribute('id', Math.abs(el.innerHTML.split("").reduce(function (a, b) {
                a = ((a << 5) - a) + b.charCodeAt(0);
                return a & a
            }, 0)));
            aElement.classList.add(classToAdd);
        }
    }
    const boutons1Matomo = document.getElementsByClassName('button bouton-matomo1 button-primary');
    Array.prototype.forEach.call(boutons1Matomo, function (el) {
        const aElement = el.querySelector('a');
        prepareBoutonMatomo(aElement, el, 'bouton-matomo1');
    });
    let linkMatomo1 = document.querySelector('a[data-style="bouton-matomo1"]');
    prepareBoutonMatomo(linkMatomo1, linkMatomo1, 'bouton-matomo1');

    const boutons2Matomo = document.getElementsByClassName('button bouton-matomo2 button-secondary');
    Array.prototype.forEach.call(boutons2Matomo, function (el) {
        const aElement = el.querySelector('a');
        prepareBoutonMatomo(aElement, el, 'bouton-matomo2');
    });
    let linkMatomo2 = document.querySelector('a[data-style="bouton-matomo2"]');
    prepareBoutonMatomo(linkMatomo2, linkMatomo2, 'bouton-matomo2');

    /* Utilitaire CSS : ajoute une variable "scrollbar-width" permettant de simplifier certaines intégrations utilisant l'unité vw. */

    // Source : https://stackoverflow.com/a/66726233
    function _calculateScrollbarWidth() {
        document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
    }

    // recalculate on resize
    window.addEventListener('resize', _calculateScrollbarWidth, false);
    // recalculate on dom load
    document.addEventListener('DOMContentLoaded', _calculateScrollbarWidth, false);
    // recalculate on load (assets loaded as well)
    window.addEventListener('load', _calculateScrollbarWidth);

    // animation texte surligne carte citation
    function isScrolledIntoView(elem) {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height() + 50;
        let elemTop = 0;
        let elemBottom = 0;
        if (elem.length > 0) {
            elemTop = $(elem).offset().top;
            elemBottom = elemTop + $(elem).height();
        }
        return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom) && (elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    $(window).scroll(function () {
        if (isScrolledIntoView($('.highlight:first-of-type')) || (isScrolledIntoView($('.highlight:last-of-type')))) {
            $(".card--citation__content .highlight").addClass('citation--anim');
        } else {
            $(".card--citation__content .highlight").removeClass('citation--anim');
        }
    });
    window.addEventListener('load', () => {
        const el = document.querySelector("#header-stuck-observer")
        if (!el) {
            return
        }
        //to check when element get's position sticky
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio < 1) {
                // no intersection
                document.body.classList.add("header-stuck")
            } else {
                // fully intersects
                document.body.classList.remove("header-stuck")
            }
        }, {
            threshold: [0, 1]
        })
        observer.observe(el)
    })
})(jQuery.noConflict());
(function () {
    /**
     * Retourne la largeur d'une "page"
     * @param $zone Élément qui englobe les items du carrousel
     * @returns {number} Largeur à faire défiler
     */
    function getPageWidth($zone) {
        return $zone.clientWidth / 2 // <= Peut être amélioré, permet de s'assurer qu'on ne va pas sauter un item
    }

    /**
     * Met à jour l'affichage du carrousel
     * @param $wrapper Élément parent du carrousel
     * @param $zone Élément qui englobe les items du carrousel
     * @param $previous Boutons de pagination en arrière
     * @param $next Boutons de pagination en avant
     */
    function updateScrollerUI($wrapper, $zone, $previous, $next) {
        // Par défaut, on désactive les boutons de pagination
        let isPreviousEnabled = false
        let isNextEnabled = false
        // Si les items ne peuvent pas être tous affichés
        if ($zone.scrollWidth > $zone.clientWidth) {
            // On indique la possibilité de retourner en arrière
            isPreviousEnabled = $zone.scrollLeft > 0
            // On indique la possibilité d'aller en avant
            isNextEnabled = $zone.scrollLeft < ($zone.scrollWidth - $zone.clientWidth)
        }
        // Mise à jour de l'état des boutons précédent et suivant
        for (const $p of $previous) {
            $p.disabled = !isPreviousEnabled
        }
        for (const $n of $next) {
            $n.disabled = !isNextEnabled
        }
        // Ajout et suppression des classes dédiées
        $wrapper.classList.toggle('is-at-start', !isPreviousEnabled)
        $wrapper.classList.toggle('is-at-end', !isNextEnabled)
    }

    function getCurrentIndex(items) {
        return items.findIndex(item => item.getAttribute('tabindex') === '0')
    }

    function updateTabIndexes(items, currentIndex = null) {
        for (const item of items) {
            item.setAttribute('tabindex', '-1')
        }
        const currentItem = items.at(currentIndex ?? 0)
        currentItem.setAttribute('tabindex', '0')
        if (currentIndex !== null) {
            currentItem.focus()
        }
    }

    /**
     * Initialise le carrousel
     * @param $wrapper Élément parent du carrousel
     */
    function bindScroller($wrapper) {
        // $zone : Élément qui englobe les items du carrousel
        // $previous : Boutons de pagination en arrière
        // $next : Boutons de pagination en avant
        // $items : Items du carrousel
        // $itemsClickableZones : Zone cliquable des items du carrousel
        const $zone = $wrapper.querySelector('[data-scroller-zone]')
        const $previous = Array.from($wrapper.querySelectorAll('[data-scroller-previous]'))
        const $next = Array.from($wrapper.querySelectorAll('[data-scroller-next]'))
        const $items = Array.from($wrapper.querySelectorAll('[data-scroller-item]'))
        const $itemsClickableZones = Array.from($wrapper.querySelectorAll('[data-scroller-item-clickable-zone]'))
        // Au chargement de la page, on remet le carrousel au début
        $zone.scrollLeft = 0
        // Prise en charge des boutons de pagination en arrière
        for (const $p of $previous) {
            $p.addEventListener('click', () => {
                const left = getPageWidth($zone) * -1
                $zone.scrollBy({left})
            })
        }
        // Prise en charge des boutons de pagination en avant
        for (const $n of $next) {
            $n.addEventListener('click', () => {
                const left = getPageWidth($zone)
                $zone.scrollBy({left})
            })
        }
        // Quand les zones cliquables des items reçoivent le focus, on les déplace au centre pour s'assurer de leur bonne visibilité
        for (const $i of $itemsClickableZones) {
            $i.addEventListener('focus', () => {
                $i.scrollIntoView({block: 'nearest', inline: 'center', behavior: 'smooth'})
            })
            $i.addEventListener('keydown', e => {
                switch (e.key) {
                    case 'ArrowLeft': {
                        e.preventDefault()
                        const currentIndex = getCurrentIndex($itemsClickableZones)
                        updateTabIndexes($itemsClickableZones, currentIndex - 1)
                        break
                    }
                    case 'ArrowRight': {
                        e.preventDefault()
                        const currentIndex = getCurrentIndex($itemsClickableZones)
                        updateTabIndexes($itemsClickableZones, (currentIndex + 1) % $itemsClickableZones.length)
                        break
                    }
                    case 'Home': {
                        e.preventDefault()
                        updateTabIndexes($itemsClickableZones, 0)
                        break
                    }
                    case 'End': {
                        e.preventDefault()
                        updateTabIndexes($itemsClickableZones, $itemsClickableZones.length - 1)
                        break
                    }
                }
            })
        }
        // En cas de resize ou scroll du wrapper, on met à jour l'interface du carrousel
        new ResizeObserver(() => updateScrollerUI($wrapper, $zone, $previous, $next)).observe($zone)
        $zone.addEventListener('scroll', () => updateScrollerUI($wrapper, $zone, $previous, $next))
        // Premier appel pour initialisation
        updateScrollerUI($wrapper, $zone, $previous, $next)
        updateTabIndexes($itemsClickableZones)
    }

    // On déclenche l'initialisation des carrousels quand la page est prête
    window.addEventListener('load', () => {
        const $scrollers = Array.from(document.querySelectorAll('.js-scroller'))
        for (const $scroller of $scrollers) {
            bindScroller($scroller)
        }
    })
    let buttons = document.querySelectorAll(".js-search-filters-suppr-button");
    for (const button of buttons) {
        let url = button.dataset.url;
        button.addEventListener("click", function (e) {
            window.open(url, "_self");
        });
    }

})()